import * as Yup from "yup";
import checkout from "./form2";

const {
  formField2: {
    period,
    firstTime,
    additional,

    taxpayers,
    taxCode,
    taxAgentName,
    taxAgentCode,

    chiefAccountant,
    certificateNumber,
    unitHeads,
    dateFounded,
  },
} = checkout;

const validation2 = Yup.object().shape({
  [period.name]: Yup.string().required(period.errorMsg),
  [firstTime.name]: Yup.string().required(firstTime.errorMsg),
  [additional.name]: Yup.number().required(additional.errorMsg),

  [taxpayers.name]: Yup.string().required(taxpayers.errorMsg),
  [taxCode.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxCode.invalidMsg)
    .required(taxCode.errorMsg),

  [taxAgentName.name]: Yup.string().optional(),
  [taxAgentCode.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxAgentCode.invalidMsg)
    .optional(),

  [chiefAccountant.name]: Yup.string().required(chiefAccountant.errorMsg),
  [certificateNumber.name]: Yup.string().required(certificateNumber.errorMsg),
  [unitHeads.name]: Yup.string().required(unitHeads.errorMsg),
  [dateFounded.name]: Yup.number().required(dateFounded.errorMsg),
});

export default validation2;
